const prefersReducedMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/* EnterView  */
const reveals = document.querySelectorAll(".reveal");
const revealUps = document.querySelectorAll(".reveal-up");

if (prefersReducedMotion() || window.Shopify?.designMode) {
  [...reveals, ...revealUps].forEach((el) => el.classList.add("entered"));
} else {
  if (reveals.length > 0) {
    enterView({
      selector: ".reveal",
      enter: (el, i) => {
        el.classList.add("entered");
      },
      exit: (el) => {
        el.classList.remove("entered");
      },
      offset: 0.1,
    });
  }

  if (revealUps.length > 0) {
    enterView({
      selector: ".reveal-up",
      enter: (el, i) => {
        el.classList.add("entered");
      },
      exit: (el) => {
        el.classList.remove("entered");
      },
      offset: 0.1,
    });
  }
}

/* Swiper Initialiser */
new Swiper("#featuredCollectionSlider", {
  direction: "horizontal",
  slidesPerView: 1.2,
  slidesOffsetBefore: 20,
  slidesOffsetAfter: 20,
  spaceBetween: 16,
  navigation: {
    nextEl: ".swiper-featured-collection-button-next",
    prevEl: ".swiper-featured-collection-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2.3,
      spaceBetween: 20,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 150,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
  },
});

new Swiper(".announcement-swiper", {
  direction: "vertical",
  loop: true,
  slidesPerView: 1,
  allowTouchMove: false,
  autoplay: prefersReducedMotion()
    ? false
    : {
        delay: 3500,
        disableOnInteraction: false,
      },
  speed: 800,
});

// MOBILE VIEWPORT HEIGHT FIX
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

window.addEventListener("resize", () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});

/* Toggle Class (Generic) */
function toggleClass(modalName, className = "active") {
  var modalActive = document.querySelector(modalName);
  modalActive.classList.toggle(className);
}

function toggleMultipleClass(selector1, selector2, className = "active") {
  const el1 = document.querySelector(selector1);
  const el2 = document.querySelector(selector2);

  if (el1) el1.classList.toggle(className);
  if (el2) el2.classList.toggle(className);
}

/* Toggle forgot password form */
const forgotPasswordButtons = document.querySelectorAll(
  ".login__forgot-password-button",
);

forgotPasswordButtons.forEach((button) => {
  button.addEventListener("click", function (e) {
    e.preventDefault();
    toggleClass(".login__form");
    toggleClass(".forgot-password-form");
  });
});

/* Open Cart */
function cartOpen() {
  document.querySelector("body").classList.add("js-my-cart-open");
}

/* Cart drawer focus */
(() => {
  const drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) return;
  const OPEN = "js-my-cart-open";
  const isOpen = () => document.body.classList.contains(OPEN);
  const outside = () => [...drawer.closest(".page-content").children].filter((el) => !el.contains(drawer));
  let lastFocus = null;
  let wasOpen = isOpen();

  new MutationObserver(() => {
    if (isOpen() === wasOpen) return;
    wasOpen = isOpen();
    if (wasOpen) lastFocus = document.activeElement;
    outside().forEach((el) => (el.inert = wasOpen));
    if (wasOpen) {
      drawer.querySelector(".cart-modal__close").focus();
    } else {
      lastFocus?.focus();
    }
  }).observe(document.body, { attributes: true, attributeFilter: ["class"] });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isOpen()) document.body.classList.remove(OPEN);
  });

  liquidAjaxCart.subscribeToCartSectionsUpdate(() => {
    if (isOpen() && !drawer.contains(document.activeElement)) drawer.focus();
  });
})();

/* FAQ Accordion */
document.querySelectorAll("[data-faq-item]").forEach((item) => {
  const trigger = item.querySelector("[data-faq-trigger]");
  if (!trigger) return;
  trigger.addEventListener("click", () => {
    const isOpen = item.classList.contains("is-open");
    item.classList.toggle("is-open", !isOpen);
    trigger.setAttribute("aria-expanded", String(!isOpen));
  });
});

/* Reduced motion: stop autoplaying section videos */
if (prefersReducedMotion()) {
  document.querySelectorAll("video[autoplay]").forEach((v) => {
    v.removeAttribute("autoplay");
    v.pause();
  });
} else {
  /* Autoplay guard: Safari can skip autoplay (Low Power Mode, bfcache restore, background tab) */
  const playAutoplayVideos = () => {
    document.querySelectorAll("video[autoplay]").forEach((v) => {
      if (!v.paused || !v.getClientRects().length) return;
      v.muted = true;
      v.play().catch(() => {});
    });
  };
  playAutoplayVideos();
  window.addEventListener("pageshow", playAutoplayVideos);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") playAutoplayVideos();
  });
  ["touchstart", "click", "keydown"].forEach((type) =>
    document.addEventListener(type, playAutoplayVideos, { once: true, passive: true })
  );
}

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({});

/* Liquid Ajax Cart */

/* Appstle's embed blanks selling_plan on /cart/add unless the URL has ?appstle=true */
liquidAjaxCart.subscribeToCartAjaxRequests((state) => {
  if (state.requestType !== "add") return;
  const fetchBefore = window.fetch;
  const flagged = function (url, options) {
    window.fetch = fetchBefore;
    if (typeof url === "string" && url.endsWith("/cart/add.js")) url += "?appstle=true";
    return fetchBefore.call(this, url, options);
  };
  window.fetch = flagged;
  queueMicrotask(() => { if (window.fetch === flagged) window.fetch = fetchBefore; }); // the request fires synchronously
});

liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
  if (state.requestType == "add") {
    const form = state.info.initiator;
    const btn = form.querySelector('button[type="submit"]');

    // Hide the label in place rather than swapping innerHTML, so price updates during the request aren't lost
    if (btn) {
      if (!btn.querySelector(":scope > .button__content")) {
        const content = document.createElement("span");
        content.className = "button__content";
        content.append(...btn.childNodes);
        btn.append(content);
      }
      btn.classList.add("is-adding");
      btn.setAttribute("aria-busy", "true");
    }

    subscribeToResult((state) => {
      if (state.responseData.ok) {
        cartOpen();
      }

      if (btn) {
        setTimeout(() => {
          btn.classList.remove("is-adding");
          btn.removeAttribute("aria-busy");
        }, 300);
      }
    });
  }
});

/* One-per-order products (free taster): lock the add button once it's in the bag */
function syncLimitOne(scope = document) {
  const state = liquidAjaxCart.getCartState();
  if (!state?.status?.cartStateSet) return;
  scope.querySelectorAll("[data-limit-one]").forEach((btn) => {
    const inCart = state.cart.items.some((item) => String(item.product_id) === btn.dataset.limitOne);
    const label = btn.querySelector("[data-limit-label]");
    if (label && !label.dataset.default) label.dataset.default = label.textContent;
    btn.disabled = inCart;
    if (label) label.textContent = inCart ? "Already in your bag" : label.dataset.default;
  });
}

// Anything that slipped past the button (double click, typed quantity) is set back to 1
function enforceLimitOne() {
  const state = liquidAjaxCart.getCartState();
  if (state?.status?.requestInProgress) return;
  const line = document.querySelector("[data-cart-limit-one]");
  if (line) liquidAjaxCart.cartRequestChange({ id: line.dataset.cartLimitOne, quantity: 1 });
}

liquidAjaxCart.subscribeToCartStateUpdate(() => syncLimitOne());
liquidAjaxCart.subscribeToCartSectionsUpdate(() => setTimeout(enforceLimitOne));
enforceLimitOne();

/* Cart discount codes: the cart keeps a list, so apply/remove resend the whole list.
   Shopify drops invalid codes silently, so a code that doesn't come back applied shows an error. */
let discountError = "";
let tasterUsed = false;
let tasterCode = ""; // kept: the form isn't rendered when the cart is empty
let tasterAutoTried = false;
let tasterCodeOn = false;

const cartDiscountCodes = () =>
  (liquidAjaxCart.getCartState().cart?.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);

function showDiscountError() {
  document.querySelectorAll("[data-cart-discount-error]").forEach((el) => {
    el.textContent = discountError;
    el.hidden = !discountError;
    if (discountError) el.closest("details").open = true;
  });
  document.querySelectorAll("[data-cart-taster-used]").forEach((el) => {
    el.hidden = !tasterUsed;
    if (tasterUsed) el.closest("details").open = true;
  });
}

document.addEventListener("submit", (e) => {
  const form = e.target.closest("[data-cart-discount-form]");
  if (!form) return;
  e.preventDefault();
  const code = form.querySelector("[data-cart-discount-input]").value.trim();
  if (!code) return;
  discountError = "";
  // Logged-in customer who's had the taster: explain instead of applying a code checkout will reject
  tasterUsed = code.toLowerCase() === (form.dataset.tasterClaimed || "").toLowerCase();
  if (tasterUsed) return showDiscountError();
  const codes = cartDiscountCodes().filter((c) => c.toLowerCase() !== code.toLowerCase());
  liquidAjaxCart.cartRequestUpdate(
    { discount: [...codes, code].join(",") },
    {
      lastComplete: (request) => {
        const returned = request.responseData?.body?.discount_codes || [];
        const match = returned.find((d) => d.code.toLowerCase() === code.toLowerCase());
        discountError = match?.applicable ? "" : `Code ${code} can't be used on this order`;
        showDiscountError();
      },
    },
  );
});

document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-cart-discount-remove]");
  if (!btn) return;
  const code = btn.dataset.cartDiscountRemove.toLowerCase();
  discountError = "";
  tasterUsed = false;
  if (code === tasterCode.toLowerCase()) tasterAutoTried = true; // don't re-add it
  liquidAjaxCart.cartRequestUpdate({ discount: cartDiscountCodes().filter((c) => c.toLowerCase() !== code).join(",") });
});

liquidAjaxCart.subscribeToCartSectionsUpdate(() => setTimeout(showDiscountError));

/* Free taster: add its code while a taster is in the bag, remove it when the taster goes. One try per page load. */
function autoApplyTasterCode() {
  const state = liquidAjaxCart.getCartState();
  if (!state?.status?.cartStateSet || state.status.requestInProgress) return;
  tasterCode = document.querySelector("[data-cart-discount-form]")?.dataset.tasterCode || tasterCode;
  const code = tasterCode;
  if (!code) return;
  const lc = code.toLowerCase();
  // the initial Liquid state has no discount_codes, so check the rendered "applied" row too
  const inState = (state.cart.discount_codes || []).some((d) => d.code.toLowerCase() === lc);
  const inDom = [...document.querySelectorAll("[data-cart-discount-remove]")].some((b) => b.dataset.cartDiscountRemove.toLowerCase() === lc);
  if (document.querySelector("[data-cart-taster]")) {
    if (inState || inDom) return void (tasterCodeOn = true);
    if (tasterAutoTried || document.querySelector("[data-taster-claimed]")) return; // already claimed
    tasterAutoTried = tasterCodeOn = true;
    liquidAjaxCart.cartRequestUpdate({ discount: [...cartDiscountCodes(), code].join(",") });
  } else {
    tasterAutoTried = false;
    if (!tasterCodeOn) return;
    tasterCodeOn = false;
    if (inState) liquidAjaxCart.cartRequestUpdate({ discount: cartDiscountCodes().filter((c) => c.toLowerCase() !== lc).join(",") });
  }
}

liquidAjaxCart.subscribeToCartSectionsUpdate(() => setTimeout(autoApplyTasterCode));
autoApplyTasterCode();

// Load more button function (collections, search)
function initLoadMore() {
  const buttons = document.querySelectorAll(".js-load-more");
  if (!buttons.length) return;

  buttons.forEach((button) => {
    if (button.dataset.initialized) return;
    button.dataset.initialized = true;

    button.addEventListener("click", function () {
      const nextUrl = button.dataset.nextUrl;
      const containerSelector = button.dataset.container;

      if (!nextUrl || !containerSelector) return;

      const container = document.querySelector(containerSelector);
      if (!container) return;

      button.classList.add("is-loading");

      fetch(nextUrl)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const newContainer = doc.querySelector(containerSelector);
          const newButton = doc.querySelector(".js-load-more");

          if (newContainer) {
            const temp = document.createElement("div");
            temp.innerHTML = newContainer.innerHTML;

            const newItems = temp.querySelectorAll(".reveal-up");

            newItems.forEach((el) => {
              el.classList.remove("entered");
            });

            while (temp.firstChild) {
              container.appendChild(temp.firstChild);
            }
            initReviewCounts(container);

            requestAnimationFrame(() => {
              newItems.forEach((el, i) => {
                el.classList.add("entered");
              });
            });
          }
          if (newButton) {
            button.dataset.nextUrl = newButton.dataset.nextUrl;
          } else {
            button.remove();
          }
        })
        .finally(() => {
          button.classList.remove("is-loading");
        });
    });
  });
}

// END OF LOAD MORE BUTTON

// Account nav
function handleAccountPageNav() {
  const pathname = window.location.pathname;
  const hash = window.location.hash;
  const links = document.querySelectorAll(".account-nav-link");

  if (!links.length) return;

  links.forEach((link) => link.classList.remove("active"));

  if (pathname === "/account") {
    const sections = document.querySelectorAll(".account-section");

    sections.forEach((section) => section.classList.add("hidden"));

    const currentHash = hash || "#dashboard";
    const sectionId = currentHash.replace("#", "account-");
    const activeSection = document.getElementById(sectionId);
    if (activeSection) {
      activeSection.classList.remove("hidden");
    }

    links.forEach((link) => {
      const hrefHash = link.getAttribute("href").split("#")[1];
      if (`#${hrefHash}` === currentHash) {
        link.classList.add("active");
      }
    });

    if (!hash) {
      window.history.replaceState(
        null,
        "",
        `${window.location.pathname}#dashboard`,
      );
    }
  }

  if (pathname.includes("/account/addresses")) {
    const addressLink = document.getElementById("addresses-link");
    addressLink?.classList.add("active");
  }
}

// Product Recommendations (PDP)
function initProductRecommendations(context = document) {
  const sections = context.querySelectorAll("[data-product-recommendations]");
  if (!sections.length) return;

  sections.forEach((section) => {
    if (section.dataset.loaded === "true") return;

    const url = section.dataset.url;

    // Manual/metafield mode — products are already in the DOM
    if (!url) {
      const wrapper = section.querySelector(".swiper-wrapper");
      if (wrapper && wrapper.children.length > 0) {
        initRecommendationSwiper(section);
        section.dataset.loaded = "true";
      }
      return;
    }

    const wrapper = section.querySelector(".swiper-wrapper");
    if (!wrapper) return;

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const temp = document.createElement("div");
        temp.innerHTML = html;

        const newSlides = temp.querySelectorAll(
          ".product-recommendations__card",
        );
        if (!newSlides.length) return;

        wrapper.innerHTML = "";

        newSlides.forEach((slide) => {
          wrapper.appendChild(slide);
        });

        initRecommendationSwiper(section);
        initReviewCounts(section);

        section.dataset.loaded = "true";
      })
      .catch((err) => {
        console.error("Recommendation fetch failed:", err);
      });
  });
}

// Review counts: live Reviews.io lookup by SKU (same as the widget) replaces the metafield count
const reviewCounts = new Map();

function initReviewCounts(context = document) {
  const rows = [...context.querySelectorAll("[data-review-skus]")];
  if (!rows.length) return;

  const store = rows[0].dataset.reviewStore;
  const skusOf = (el) => el.dataset.reviewSkus.split(";").filter(Boolean);
  const missing = [...new Set(rows.flatMap(skusOf))].filter((sku) => !reviewCounts.has(sku));
  const batches = [];
  for (let i = 0; i < missing.length; i += 50) batches.push(missing.slice(i, i + 50));

  Promise.all(
    batches.map((skus) =>
      fetch(`https://api.reviews.io/product/rating-batch?store=${encodeURIComponent(store)}&sku=${encodeURIComponent(skus.join(";"))}`)
        .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
        .then((data) => {
          skus.forEach((sku) => reviewCounts.set(sku, 0));
          data.forEach((item) => reviewCounts.set(item.sku, Number(item.num_ratings) || 0));
        }),
    ),
  )
    .then(() => {
      rows.forEach((el) => {
        const total = skusOf(el).reduce((sum, sku) => sum + (reviewCounts.get(sku) || 0), 0);
        if (!total) return;
        el.querySelector("[data-review-count]").textContent = total;
        el.hidden = false;
      });
    })
    .catch(() => {});
}

// Product recommendations swiper
function initRecommendationSwiper(section) {
  const swiperEl = section.querySelector("[data-recommendation-swiper]");
  if (!swiperEl) return;

  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true);
  }

  new Swiper(swiperEl, {
    ...productSliderOptions,
    navigation: {
      nextEl: swiperEl.querySelector(".product-slider__nav--next"),
      prevEl: swiperEl.querySelector(".product-slider__nav--prev"),
    },
  });
}

// Collection Filtering //
function initCollectionFacets() {
  const collectionPage = document.querySelector(".js-collection-page");
  if (!collectionPage) return;

  const modal = collectionPage.querySelector("#FiltersModal");
  const openBtn = collectionPage.querySelector(".open-filters");
  const closeBtn = collectionPage.querySelector(".filters-close");
  const overlay = collectionPage.querySelector(".filters-overlay");
  const form = collectionPage.querySelector("#FiltersForm");
  const countEl = collectionPage.querySelector("#ActiveFilterCount");
  const headerCountEl = collectionPage.querySelector(
    "#ActiveFilterCountHeader",
  );
  const applyButton = collectionPage.querySelector(".filter__apply-button");

  if (!modal) return;

  // Open/close modal
  const openModal = () => {
    modal.classList.add("active");
    document.body.classList.add("no-scroll");
  };

  const closeModal = () => {
    modal.classList.remove("active");
    document.body.classList.remove("no-scroll");
  };

  openBtn?.addEventListener("click", openModal);
  closeBtn?.addEventListener("click", closeModal);
  overlay?.addEventListener("click", closeModal);
  form?.addEventListener("submit", closeModal);

  // Accordion
  collectionPage.querySelectorAll(".js-accordion-toggle").forEach((toggle) => {
    toggle.addEventListener("click", (e) => {
      e.preventDefault();
      const group = toggle.closest(".filter-group");
      const options = group?.querySelector(".filter-options");
      options?.classList.toggle("active");
      toggle.classList.toggle("active");
    });
  });

  // checkbox states
  const syncActiveCheckboxes = () => {
    collectionPage
      .querySelectorAll('.filter-options input[type="checkbox"]')
      .forEach((input) => {
        const label = input.closest("label");
        if (!label) return;
        label.classList.toggle("is-active", input.checked);
      });
  };

  collectionPage.addEventListener("change", (e) => {
    const input = e.target;

    if (input.type === "checkbox" || input.type === "radio") {
      const label = input.closest("label");
      label?.classList.toggle("is-active", input.checked);

      // For radios, remove active from siblings
      if (input.type === "radio") {
        const radios = collectionPage.querySelectorAll(
          `input[name="${input.name}"]`,
        );
        radios.forEach((radio) => {
          const l = radio.closest("label");
          l?.classList.toggle("is-active", radio.checked);
        });
      }
    }

    updateFilterCount();
    updateProductCount();
  });

  const updateFilterCount = () => {
    if (!form) return;

    let count = 0;

    const checkedBoxes = form.querySelectorAll(
      'input[type="checkbox"]:checked',
    );
    count += checkedBoxes.length;

    const minInput = form.querySelector('input[name*="filter.v.price.gte"]');
    const maxInput = form.querySelector('input[name*="filter.v.price.lte"]');

    if (minInput?.value || maxInput?.value) {
      count += 1;
    }

    const formatted = count > 0 ? `(${count})` : "";

    if (countEl) countEl.textContent = formatted;
    if (headerCountEl) headerCountEl.textContent = formatted;
  };

  const updateProductCount = async () => {
    if (!form || !applyButton) return;

    const url = new URL(form.action, window.location.origin);
    const params = new URLSearchParams();

    // Checkboxes
    form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
      params.append(input.name, input.value);
    });

    // Radios
    form.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
      params.append(input.name, input.value);
    });

    // Price range
    const minInput = form.querySelector('input[name*="filter.v.price.gte"]');
    const maxInput = form.querySelector('input[name*="filter.v.price.lte"]');

    if (minInput?.value) {
      params.append(minInput.name, minInput.value);
    }

    if (maxInput?.value) {
      params.append(maxInput.name, maxInput.value);
    }

    try {
      const response = await fetch(`${url.pathname}?${params.toString()}`);
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const countEl = doc.querySelector(".collection__filter-number");
      const productCount = countEl?.textContent.match(/\d+/)?.[0] || 0;

      applyButton.textContent = `View ${productCount} Products`;
    } catch (error) {
      console.error("Error fetching product count:", error);
    }
  };

  syncActiveCheckboxes();
  updateFilterCount();
}

// Announcement bar
function initAnnouncementBar() {
  const body = document.body;
  const bar = document.getElementById("announcement-bar");

  if (!bar) return;

  let dismissed = false;
  try {
    dismissed = sessionStorage.getItem("announcementDismissed") === "1";
  } catch (e) {
    /* storage unavailable — show the bar */
  }
  if (dismissed) return;

  bar.classList.remove("hidden-by-default");
  body.classList.add("announcement-bar-visible");

  const closeBtn = document.getElementById("announcement-bar-close");
  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      bar.remove();
      body.classList.remove("announcement-bar-visible");
      try {
        sessionStorage.setItem("announcementDismissed", "1");
      } catch (e) {
        /* non-persistent dismiss is fine */
      }
    });
  }
}

function initGeoModal() {
  const modal = document.getElementById("geo-modal");
  if (!modal) return;

  if (localStorage.getItem("geoModalSeen")) return;

  const shopBtn = modal.querySelector("#geo-modal-shop");

  setTimeout(() => {
    modal.classList.add("active");
  }, 1200);

  function closeModal() {
    modal.classList.remove("active");
    localStorage.setItem("geoModalSeen", "true");
  }

  shopBtn?.addEventListener("click", () => {
    const form = modal.querySelector("form");

    localStorage.setItem("geoModalSeen", "true");

    if (form && form.dataset.currencyChanged === "true") {
      form.submit();
    } else {
      closeModal();
    }
  });
}

function initCurrencySelectors() {
  const selectors = document.querySelectorAll(".currency-selector");
  if (!selectors.length) return;

  selectors.forEach((selector) => {
    const form = selector.closest("form");
    const insideModal = selector.closest("#geo-modal");

    resizeCurrencySelector(selector);

    selector.addEventListener("change", () => {
      resizeCurrencySelector(selector);

      if (insideModal) {
        form.dataset.currencyChanged = "true";
        return;
      }

      form.submit();
    });
  });
}

function resizeCurrencySelector(selector) {
  let temp = selector._tempMeasure;

  if (!temp) {
    temp = document.createElement("span");
    temp.style.visibility = "hidden";
    temp.style.position = "absolute";
    temp.style.whiteSpace = "nowrap";
    temp.style.font = window.getComputedStyle(selector).font;

    document.body.appendChild(temp);
    selector._tempMeasure = temp;
  }

  const text = selector.options[selector.selectedIndex].text;
  temp.textContent = text;

  const textWidth = temp.offsetWidth;

  const style = window.getComputedStyle(selector);
  const padding =
    parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);

  const buffer = 24;

  selector.style.width = textWidth + padding + buffer + "px";
}

// Init functions
window.addEventListener("hashchange", handleAccountPageNav);


/* Method steps tab switcher */
function initMethodSteps(context = document) {
  context.querySelectorAll("[data-method-steps]").forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = "1";
    const tabs = [...root.querySelectorAll("[data-ms-tab]")];
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle("is-active", active);
          t.setAttribute("aria-selected", String(active));
        });
        root.querySelectorAll("[data-ms-panel]").forEach((p) => {
          const active = p.dataset.msPanel === tab.dataset.msTab;
          p.classList.toggle("is-active", active);
          p.querySelectorAll("video").forEach((v) => {
            if (active && !prefersReducedMotion()) v.play().catch(() => {});
            else v.pause();
          });
        });
      });
    });
  });
}

/* Content drawer: carousel cards open a panel below */
function initContentDrawers(context = document) {
  context.querySelectorAll("[data-content-drawer]").forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = "1";

    const swiperEl = root.querySelector(".swiper");
    if (swiperEl && typeof Swiper !== "undefined") {
      new Swiper(swiperEl, {
        on: centreNavEvents,
        slidesPerView: 1.4,
        spaceBetween: 8,
        breakpoints: {
          600: { slidesPerView: 2.4 },
          1024: { slidesPerView: 3.2 },
          1280: { slidesPerView: 4 },
        },
        navigation: {
          prevEl: root.querySelector(".product-slider__nav--prev"),
          nextEl: root.querySelector(".product-slider__nav--next"),
        },
      });
    }

    const drawer = root.querySelector("[data-cdrawer-drawer]");
    const triggers = [...root.querySelectorAll("[data-cdrawer-trigger]")];
    const panels = [...root.querySelectorAll("[data-cdrawer-panel]")];
    if (!drawer) return;
    let current = null;

    // Animate drawer height from its current size to whatever `change` leaves it at
    function animate(change, done) {
      const from = drawer.offsetHeight;
      change();
      const to = drawer.scrollHeight;
      if (prefersReducedMotion() || from === to) {
        drawer.style.height = "";
        done?.();
        return;
      }
      drawer.style.height = from + "px";
      drawer.offsetHeight;
      drawer.style.height = to + "px";
      afterHeight(() => {
        drawer.style.height = "";
        done?.();
      });
    }

    function afterHeight(fn) {
      const end = (e) => {
        if (e.target !== drawer || e.propertyName !== "height") return;
        drawer.removeEventListener("transitionend", end);
        fn();
      };
      drawer.addEventListener("transitionend", end);
    }

    function show(i) {
      panels.forEach((p) => (p.hidden = p.dataset.cdrawerPanel !== i));
      triggers.forEach((t) => t.setAttribute("aria-expanded", String(t.dataset.cdrawerTrigger === i)));
    }

    function open(i) {
      const switching = current !== null;
      current = i;
      const panel = panels.find((p) => p.dataset.cdrawerPanel === i);
      animate(
        () => {
          drawer.classList.add("is-open");
          show(i);
          if (switching) {
            panel.classList.add("is-swapping");
            panel.offsetHeight;
            panel.classList.remove("is-swapping");
          }
        },
        () => {
          if (drawer.getBoundingClientRect().bottom > window.innerHeight) {
            const tall = drawer.offsetHeight > window.innerHeight * 0.8;
            drawer.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: tall ? "start" : "nearest" });
          }
        },
      );
    }

    function close() {
      const trigger = triggers.find((t) => t.dataset.cdrawerTrigger === current);
      current = null;
      drawer.style.height = drawer.offsetHeight + "px";
      drawer.classList.remove("is-open");
      drawer.offsetHeight;
      const finish = () => {
        if (current !== null) return; // reopened mid-close
        drawer.style.height = "";
        show(null);
      };
      trigger?.focus();
      if (prefersReducedMotion()) return finish();
      drawer.style.height = "0px";
      afterHeight(finish);
    }

    triggers.forEach((t) =>
      t.addEventListener("click", () => {
        const i = t.dataset.cdrawerTrigger;
        if (i === current) close();
        else open(i);
      }),
    );
    root.querySelectorAll("[data-cdrawer-close]").forEach((b) => b.addEventListener("click", close));
  });
}

/* Recipe grid */
function initRecipeGrids(context = document) {
  context.querySelectorAll("[data-recipe-grid]").forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = "1";

    const modal = root.querySelector("[data-recipe-modal]");
    const body = root.querySelector("[data-recipe-body]");
    if (!modal || !body || typeof modal.showModal !== "function") return;
    let trigger = null;

    root.addEventListener("click", (e) => {
      const card = e.target.closest("[data-recipe-open]");
      if (!card || !root.contains(card)) return;
      const template = card.parentElement.querySelector("[data-recipe-panel]");
      if (!template) return;
      trigger = card;
      body.replaceChildren(template.content.cloneNode(true));
      modal.style.cssText = body.querySelector(".cdrawer__panel")?.style.cssText || "";
      const heading = body.querySelector("h3");
      if (heading) modal.setAttribute("aria-labelledby", heading.id);
      else modal.removeAttribute("aria-labelledby");
      modal.scrollTop = 0;
      modal.showModal();
      modal.querySelector("[data-recipe-close]")?.focus();
    });

    modal.querySelector("[data-recipe-close]")?.addEventListener("click", () => modal.close());
    modal.addEventListener("click", (e) => {
      if (e.target === modal) modal.close();
    });
    modal.addEventListener("close", () => {
      body.replaceChildren();
      trigger?.focus();
      trigger = null;
    });
  });
}

/* Feature banner (sticky auto-advancing slider) */
function initFeatureBanners(context = document) {
  context.querySelectorAll("[data-feature-banner]").forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = "1";

    const pills = [...root.querySelectorAll("[data-fb-pill]")];
    const duration = parseInt(root.dataset.autoplay, 10) || 6000;
    root.style.setProperty("--fb-duration", duration + "ms");
    const auto = !prefersReducedMotion() && pills.length > 1;
    let current = 0;
    let timer = null;

    function activate(i) {
      current = i;
      root.querySelectorAll("[data-fb-media]").forEach((el) => {
        const active = el.dataset.fbMedia == i;
        el.classList.toggle("is-active", active);
        const video = el.querySelector("video");
        if (video) {
          if (active && !prefersReducedMotion()) video.play().catch(() => {});
          else video.pause();
        }
      });
      root.querySelectorAll("[data-fb-text]").forEach((el) => {
        el.classList.toggle("is-active", el.dataset.fbText == i);
      });
      pills.forEach((p) => {
        const active = p.dataset.fbPill == i;
        p.classList.remove("is-filling");
        p.classList.toggle("is-active", active);
        p.setAttribute("aria-selected", String(active));
        if (active) {
          root.style.setProperty("--fb-accent-active", p.style.getPropertyValue("--fb-accent"));
          if (auto) {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => p.classList.add("is-filling"));
            });
          }
        }
      });
    }

    function schedule() {
      clearTimeout(timer);
      if (!auto) return;
      timer = setTimeout(() => {
        activate((current + 1) % pills.length);
        schedule();
      }, duration);
    }

    pills.forEach((p) => {
      p.addEventListener("click", () => {
        activate(parseInt(p.dataset.fbPill, 10));
        schedule();
      });
    });

    activate(0);
    schedule();
  });
}

/* FAQ groups */
function initFaqGroups(context = document) {
  context.querySelectorAll("[data-faq-groups]").forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = "1";

    const pills = [...root.querySelectorAll("[data-faq-pill]")];
    const groups = [...root.querySelectorAll("[data-faq-group]")];
    if (!pills.length || !groups.length) return;

    let ticking = false;
    let lockUntil = 0;

    function setActive(id) {
      pills.forEach((p) => p.classList.toggle("is-active", p.dataset.faqPill === id));
    }

    pills.forEach((p) => {
      p.addEventListener("click", () => {
        setActive(p.dataset.faqPill);
        lockUntil = Date.now() + 900;
      });
    });

    function update() {
      if (Date.now() < lockUntil) return;
      const line = window.scrollY + window.innerHeight * 0.25;
      const doc = document.documentElement;
      let active = groups[0];

      if (window.scrollY + window.innerHeight >= doc.scrollHeight - 2) {
        active = groups[groups.length - 1];
      } else {
        groups.forEach((g) => {
          if (g.getBoundingClientRect().top + window.scrollY <= line) active = g;
        });
      }

      setActive(active.dataset.faqGroup);
    }

    window.addEventListener("scroll", () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    });

    update();
  });
}

/* Slider arrows centre on the card images */
function centreSliderNav(swiper) {
  const media = swiper.slides[0]?.querySelector(".pcard__media, .cdrawer__card-media");
  if (!media || !media.offsetHeight) return;
  let top = media.offsetHeight / 2;
  for (let el = media; el && el !== swiper.el; el = el.offsetParent) top += el.offsetTop;
  swiper.el.style.setProperty("--nav-centre", `${top}px`);
}

const centreNavEvents = { init: centreSliderNav, resize: centreSliderNav, update: centreSliderNav };

/* Product slider + related products */
const productSliderOptions = {
  on: centreNavEvents,
  slidesPerView: 1.4,
  spaceBetween: 8,
  breakpoints: {
    600: { slidesPerView: 2.4 },
    1024: { slidesPerView: 3.2 },
    1280: { slidesPerView: 4.2 },
  },
};

/* Product slider (tabbed collection carousels) */
function initProductSliders(context = document) {
  context.querySelectorAll("[data-product-slider]").forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = "1";

    const swipers = {};
    root.querySelectorAll("[data-slider-set]").forEach((setEl) => {
      swipers[setEl.dataset.sliderSet] = new Swiper(setEl, {
        ...productSliderOptions,
        navigation: {
          nextEl: setEl.querySelector(".product-slider__nav--next"),
          prevEl: setEl.querySelector(".product-slider__nav--prev"),
        },
      });
    });

    const tabs = root.querySelectorAll("[data-slider-tab]");
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.forEach((t) => {
          t.classList.toggle("is-active", t === tab);
          t.setAttribute("aria-selected", String(t === tab));
        });
        root.querySelectorAll("[data-slider-set]").forEach((setEl) => {
          setEl.classList.toggle("hidden", setEl.dataset.sliderSet !== tab.dataset.sliderTab);
        });
        swipers[tab.dataset.sliderTab]?.update();
      });
    });
  });
}

/* Purchase toggle: plans + prices for the current variant. Called after variant changes. */
function syncPurchase(scope) {
  const root = scope?.querySelector("[data-selling-plan-selector]");
  const dataEl = root?.querySelector("[data-purchase-data]");
  if (!dataEl) return;
  const variant = JSON.parse(dataEl.textContent)[root.closest("form")?.querySelector('[name="id"]')?.value];
  if (!variant) return;

  const select = root.querySelector("[data-selling-plan-select]");
  const options = [...select.options];
  options.forEach((o) => (o.hidden = o.disabled = !(o.value in variant.plans)));
  const available = options.filter((o) => !o.disabled);
  root.hidden = available.length === 0;
  if (available.length && select.selectedOptions[0]?.disabled) select.value = available[0].value;

  const subscribe =
    available.length > 0 && !!root.querySelector('[data-purchase-type][value="subscribe"]:checked');
  root.querySelector("[data-purchase-frequency]").hidden = !subscribe;
  select.disabled = !subscribe;

  const price = subscribe ? variant.plans[select.value] : variant.price;
  const compare = subscribe ? variant.subscribeCompare : variant.compare;
  scope.querySelectorAll("[data-purchase-price]:not([data-price-locked])").forEach((el) => (el.textContent = price));
  scope.querySelectorAll("[data-purchase-compare]").forEach((el) => {
    el.textContent = compare || "";
    el.style.display = compare ? "" : "none";
  });
}

/* Upsell selects: plans follow the size; selling_plan only posted when one is picked */
document.addEventListener("change", (e) => {
  if (!e.target.matches("[data-upsell-variant], [data-upsell-plan]")) return;
  const card = e.target.closest(".cart-modal__upsell-card");
  const variant = JSON.parse(card.querySelector("[data-upsell-data]").textContent)[card.querySelector('[name="id"]').value];
  if (!variant) return;
  let price = variant.price;
  const plan = card.querySelector("[data-upsell-plan]");
  if (plan) {
    [...plan.options].forEach((o) => {
      if (o.value) o.hidden = o.disabled = !(o.value in variant.plans);
    });
    if (plan.selectedOptions[0].disabled) plan.value = "";
    plan.closest(".cart-modal__upsell-plan").hidden = Object.keys(variant.plans).length === 0;
    if (plan.value) {
      plan.setAttribute("name", "selling_plan");
      price = variant.plans[plan.value];
    } else {
      plan.removeAttribute("name");
    }
  }
  card.querySelectorAll("[data-upsell-price]").forEach((el) => (el.textContent = price));
});

/* Delegated so quick-add panels loaded later work too. */
document.addEventListener("change", (e) => {
  if (!e.target.matches("[data-purchase-type], [data-selling-plan-select]")) return;
  syncPurchase(e.target.closest("[data-purchase-scope]"));
});

document.addEventListener("DOMContentLoaded", function () {
  initLoadMore();
  handleAccountPageNav();
  initProductRecommendations();
  initCollectionFacets();
  initAnnouncementBar();
  initProductSliders();
  initFeatureBanners();
  initMethodSteps();
  initContentDrawers();
  initRecipeGrids();
  initFaqGroups();
  initGeoModal();
  initCurrencySelectors();
  initReviewCounts();
});

document.addEventListener("shopify:section:load", (event) => {
  initReviewCounts(event.target);
  initProductRecommendations(event.target);
  initProductSliders(event.target);
  initFeatureBanners(event.target);
  initMethodSteps(event.target);
  initContentDrawers(event.target);
  initRecipeGrids(event.target);
  initFaqGroups(event.target);
});
